import { Selector } from "@ngxs/store";
import { LanguageState, LanguageStateModel } from "./language.state";
import { Language } from "../../interfaces/language";

export class LanguagesSelectors {

  @Selector([LanguageState])
  static getLanguages(state: LanguageStateModel): Language[] {
    return state.languages;
  }

}
